<template>
  <div class="issues-section">
    <div class="issues-header">
      <h3 class="section-title">
        Priority Issues
        <span class="need-action-badge">{{ needActionCount }} Need Action</span>
      </h3>
      <div class="header-actions">
        <button class="export-button" :disabled="exporting" @click="$emit('export')">
          <i class="download icon"></i>
          {{ exporting ? 'Exporting…' : 'Export CSV' }}
        </button>
        <a @click="$emit('viewAll')" class="view-all-link">
          View all {{ totalIssues }} issues >
        </a>
      </div>
    </div>

    <div class="issues-table-header">
      <span>PRODUCT</span>
      <span>STATUS</span>
      <span class="est-daily-header">
        EST. DAILY
        <i class="info circle icon" title="Estimated daily revenue impact"></i>
      </span>
      <span style="text-align: center">ACTION</span>
    </div>

    <div class="section-dev-notes" v-if="false"><!-- Dev notes placeholder --></div>

    <div class="issues-list">
      <div
        v-for="(issue, index) in issues"
        :key="index"
        class="issue-row"
      >
        <div class="product-cell">
          <div class="product-image-wrap">
            <div class="product-image-placeholder"></div>
            <img v-if="issue.imageUrl" :src="issue.imageUrl" :alt="issue.product" class="product-image" @error="e => e.target.style.display = 'none'" />
          </div>
          <div class="product-info">
            <div class="product-name-line">
              <span class="product-name clickable" @click="$emit('product-click', issue)">{{ issue.product }}</span>
            </div>
            <span v-if="issue.asin" class="product-asin">{{ issue.asin }}</span>
          </div>
        </div>
        <div class="status-cell">
          <span class="issue-status" :class="issue.statusType">{{ issue.status }}</span>
        </div>
        <div class="impact-cell">
          <span class="impact-value" :class="issue.impactClass">{{ issue.impact }}</span>
        </div>
        <div class="action-cell">
          <a class="view-details-link" @click="$emit('action-click', issue)">
            View Details >
          </a>
        </div>
      </div>
    </div>

    <div v-if="syncing" class="sync-issues-note">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2980b9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>
      <span>Buy Box issues will appear here once the scan completes.</span>
    </div>
  </div>
</template>

<script>
import './styles/PriorityIssuesList.css'

export default {
  name: 'PriorityIssuesList',
  props: {
    issues: {
      type: Array,
      required: true
    },
    needActionCount: {
      type: Number,
      default: 0
    },
    totalIssues: {
      type: Number,
      required: true
    },
    syncing: {
      type: Boolean,
      default: false
    },
    exporting: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getConfidenceDotClass: function(issue) {
      // Use confidence level when available, else fall back to status-based
      if (issue.confidenceLevel) {
        if (issue.confidenceLevel === 'high') return 'high'
        if (issue.confidenceLevel === 'medium') return 'medium'
        if (issue.confidenceLevel === 'low') return 'low'
      }
      // Fallback: status-based (critical, warning, info, success)
      if (issue.statusType === 'suppressed') return 'status-suppressed'
      if (issue.statusType === 'lost') return 'status-lost'
      if (issue.statusType === 'contested') return 'status-contested'
      if (issue.statusType === 'owned') return 'status-owned'
      return 'medium'
    }
  }
}
</script>





// WEBPACK FOOTER //
// PriorityIssuesList.vue?7b917afe